'use client';

import type { ReactNode } from 'react';

import { UserDebugProvider } from './debugger';
import { UserProvider, type UserProviderProps } from './provider';

export type InfinexUserProviderProps = UserProviderProps & {
  children: ReactNode;
};

export function InfinexUserProvider({
  children,
  ...userProviderProps
}: InfinexUserProviderProps) {
  return (
    <UserDebugProvider>
      <UserProvider {...userProviderProps}>{children}</UserProvider>
    </UserDebugProvider>
  );
}
